export { default } from './useGetStudentType';
